import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-top",
  "use": "icon-top-usage",
  "viewBox": "0 0 16 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 9\" id=\"icon-top\">\r\n  <path d=\"M14,7,7,0,0,7\" transform=\"translate(1 1)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol